<template>
    <div class="add-safety-data-sheet-wrapper container-fluid p-t-25 p-r-0 p-l-0">
        <div class="pull-right">
            <button type="button"
                    class="btn btn-lg btn-primary"
                    @click="showSafetyDataSheetUploadModal">
                <i class="fa fa-plus"></i>
                Add Safety Data Sheet
            </button>
        </div>

        <!-- SAFETY DATA SHEET UPLOAD MODAL -->
        <div ref="safetyDataSheetUploadModal" class="modal fade" role="dialog" tabindex="-1">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">Add Safety Data Sheet</h4>
                    </div>

                    <div class="modal-body container-fluid">
                        <div class="p-l-25 p-r-25 p-t-10">
                            <div class="p-5">
                                <label>Choose an Account</label>
                                <select class="form-control" ref="safetyDataSheetAccount">
                                    <option :value="account.account_nbr" v-for="account in accounts" >
                                        #{{ account.account_nbr }} {{ account.account_nm }} ({{ account.city }}, {{ account.state_cd }})
                                    </option>
                                </select>
                            </div>

                            <div class="p-5" @change="sheetChanged" :class="{ 'error-border':!sheetSelected }">
                                <label>Select a Safety Data Sheet</label>
                                <input type="file" id="file" name="file" ref="safetyDataSheetFile" accept="application/pdf" required="true">
                            </div>

                            <div class="p-5" @change="descriptionChanged" :class="{ 'error-border': !descriptionEntered }">
                                <label>Enter a Sample Type or Sample ID</label>
                                <textarea class="form-control" ref="safetyDataSheetDescription" placeholder="Required"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button"
                                class="btn btn-lg btn-primary"
                                :class="{ 'disabled': !sheetSelected && !descriptionEntered }"
                                @click="uploadSafetyDataSheet">
                            <i class="fa fa-plus"></i>
                            Add
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import 'resources/assets/sass/global_variables';
    
    .error-border input,
    .error-border textarea,
    .error-border select {
        border: 2px solid red;
    }
</style>

<script>
    import {mapState} from 'vuex';

    module.exports = {
        props: { },

        data: function() {
            return {
                accounts: [],
                sheetSelected: false,
                descriptionEntered: false
            }
        },

        computed: {
            ...mapState('documents', {
                docTypes: 'docTypes',
                needToSearch: 'needToSearch',
            }),

        },
        
        watch: {
        },

        methods: {
            showSafetyDataSheetUploadModal() {
                this.getAccounts();
                $(this.$refs.safetyDataSheetUploadModal).modal();
            },
            
            uploadSafetyDataSheet () {
                const file = this.$refs.safetyDataSheetFile;
                const account = this.$refs.safetyDataSheetAccount;
                const description = this.$refs.safetyDataSheetDescription;
                const fileReader = new FileReader();

                fileReader.onloadend = () => {
                    this.$http.post('/documents/sds/new', {
                        accountNumber : parseInt(account.value),
                        fileName : file.files[0].name,
                        fileContents : btoa(fileReader.result),
                        fileDescription : description.value
                    }).then( function() {
                        $(this.$refs.safetyDataSheetUploadModal).modal('hide');
                        this.refreshDocuments ();
                    });
                }
                
                fileReader.readAsBinaryString(file.files[0]);
            },

            refreshDocuments: function () {
                this.$emit('refresh');
            },

            getAccounts: function(success) {
                this.$http.get('/user/accounts', {
                    params: {
                        roles: ["ANLYSIS"]
                    }
                }).then(function(response) {
                    this.accounts.splice(0,this.accounts.length);
                    if (response.data) {
                        for (let i=0;i<response.data.length;i++) {
                            let account = response.data[i];
                            if (this.accounts.map(function(a){ return a.account_nbr }).indexOf(account.account_nbr) == -1) {
                                this.accounts.push(account);
                            }
                        }
                    }
                    if (typeof success === 'function') success(response);
                });
            },

            sheetChanged: function () {
                const sheet = this.$refs.safetyDataSheetFile;
                this.sheetSelected =  ((sheet && sheet.files && sheet.files[0]) ? true : false);
            },

            descriptionChanged: function() {
                const description = this.$refs.safetyDataSheetDescription;
                this.descriptionEntered =  ((description && description.value != null && description.value != "") ? true : false);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// add-safety-data-sheet.vue?07a3c954